import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import CSSAnimationGroupChild from './css-animation-group-child';
import normalizeTime from './lib/normalize-time';
import { directionType, fillModeType, timeType, componentType } from './lib/prop-types';

var CSSAnimationGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(CSSAnimationGroup, _Component);

  function CSSAnimationGroup() {
    var _context;

    var _this;

    _classCallCheck(this, CSSAnimationGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CSSAnimationGroup).call(this));
    _this.childFactory = _bindInstanceProperty(_context = _this.childFactory).call(_context, _assertThisInitialized(_this));
    return _this;
  }

  _createClass(CSSAnimationGroup, [{
    key: "childFactory",
    value: function childFactory(child, index) {
      var _this$props = this.props,
          enterAnimation = _this$props.enterAnimation,
          enterDelay = _this$props.enterDelay,
          enterDirection = _this$props.enterDirection,
          enterDuration = _this$props.enterDuration,
          enterFillMode = _this$props.enterFillMode,
          enterIterationCount = _this$props.enterIterationCount,
          enterTimingFunction = _this$props.enterTimingFunction,
          leaveAnimation = _this$props.leaveAnimation,
          leaveDelay = _this$props.leaveDelay,
          leaveDirection = _this$props.leaveDirection,
          leaveDuration = _this$props.leaveDuration,
          leaveFillMode = _this$props.leaveFillMode,
          leaveIterationCount = _this$props.leaveIterationCount,
          leaveTimingFunction = _this$props.leaveTimingFunction,
          enterOnAppear = _this$props.enterOnAppear;
      return React.createElement(CSSAnimationGroupChild, {
        key: index,
        enterAnimation: {
          delay: normalizeTime(enterDelay),
          direction: enterDirection,
          duration: normalizeTime(enterDuration),
          fillMode: enterFillMode,
          iterationCount: enterIterationCount,
          name: enterAnimation,
          timingFunction: enterTimingFunction
        },
        leaveAnimation: {
          delay: normalizeTime(leaveDelay),
          direction: leaveDirection,
          duration: normalizeTime(leaveDuration),
          fillMode: leaveFillMode,
          iterationCount: leaveIterationCount,
          name: leaveAnimation,
          timingFunction: leaveTimingFunction
        },
        enterOnAppear: enterOnAppear
      }, child);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          component = _this$props2.component,
          enterAnimation = _this$props2.enterAnimation,
          enterDelay = _this$props2.enterDelay,
          enterDirection = _this$props2.enterDirection,
          enterDuration = _this$props2.enterDuration,
          enterFillMode = _this$props2.enterFillMode,
          enterIterationCount = _this$props2.enterIterationCount,
          enterTimingFunction = _this$props2.enterTimingFunction,
          leaveAnimation = _this$props2.leaveAnimation,
          leaveDelay = _this$props2.leaveDelay,
          leaveDirection = _this$props2.leaveDirection,
          leaveDuration = _this$props2.leaveDuration,
          leaveFillMode = _this$props2.leaveFillMode,
          leaveIterationCount = _this$props2.leaveIterationCount,
          leaveTimingFunction = _this$props2.leaveTimingFunction,
          enterOnAppear = _this$props2.enterOnAppear,
          restProps = _objectWithoutProperties(_this$props2, ["component", "enterAnimation", "enterDelay", "enterDirection", "enterDuration", "enterFillMode", "enterIterationCount", "enterTimingFunction", "leaveAnimation", "leaveDelay", "leaveDirection", "leaveDuration", "leaveFillMode", "leaveIterationCount", "leaveTimingFunction", "enterOnAppear"]);

      return React.createElement(TransitionGroup, _extends({}, restProps, {
        component: component,
        childFactory: this.childFactory
      }));
    }
  }]);

  return CSSAnimationGroup;
}(Component);

_defineProperty(CSSAnimationGroup, "propTypes", {
  component: componentType,
  enterAnimation: PropTypes.string,
  enterDelay: timeType,
  enterDirection: directionType,
  enterDuration: timeType,
  enterFillMode: fillModeType,
  enterIterationCount: PropTypes.number,
  enterTimingFunction: PropTypes.string,
  leaveAnimation: PropTypes.string,
  leaveDelay: timeType,
  leaveDirection: directionType,
  leaveDuration: timeType,
  leaveFillMode: fillModeType,
  leaveIterationCount: PropTypes.number,
  leaveTimingFunction: PropTypes.string,
  enterOnAppear: PropTypes.bool
});

_defineProperty(CSSAnimationGroup, "defaultProps", {
  component: 'span',
  enterAnimation: '',
  enterDelay: 0,
  enterDirection: 'normal',
  enterDuration: 0,
  enterFillMode: 'none',
  enterIterationCount: 1,
  enterTimingFunction: 'ease',
  leaveAnimation: '',
  leaveDelay: 0,
  leaveDirection: 'normal',
  leaveDuration: 0,
  leaveFillMode: 'none',
  leaveIterationCount: 1,
  leaveTimingFunction: 'ease',
  enterOnAppear: false
});

export default CSSAnimationGroup;